<template>
  <div class="editProfile">
    <van-form
      ref="validateForm"
      validate-first
      input-align="right"
      :show-error="false"
      :show-error-message="false"
    >
      <van-field
        required
        rows="1"
        autosize
        type="textarea"
        v-model.trim="userInfo.name"
        label="真实姓名"
        placeholder="请输入真实姓名"
        :rules="[{ required: true, message: '请输入真实姓名' }]"
      />
      <van-field
        required
        v-model.trim="userInfo.idCardNo"
        label="身份证号"
        readonly
      >
        <template v-if="!userInfo.idCardNo" #button>
          <van-button size="small" type="primary" color="#1972ff" @click="toIdentify">前往身份认证</van-button>
        </template>
      </van-field>
      <van-field
        required
        label="性别"
        placeholder="请选择性别"
        :rules="[{ validator: genderValidator, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group v-model="userInfo.gender" direction="horizontal">
            <van-radio :name="1">男</van-radio>
            <van-radio :name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        required
        readonly
        clickable
        right-icon="arrow"
        :value="userInfo.birthday && userInfo.birthday.substring(0, 11)"
        label="出生日期"
        placeholder="请选择出生日期"
        :rules="[{ required: true, message: '请选择出生日期' }]"
        @click="showBirthdayPicker = true"
      />
      <van-popup v-model="showBirthdayPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="请选择出生日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="birthdayOnConfirm"
          @cancel="showBirthdayPicker = false"
        />
      </van-popup>
      <div class="handle_btn">
        <van-button
          round
          block
          plain
          type="info"
          class="cancel_btn"
          @click="cancelHandle"
          >取消</van-button
        >
        <van-button round block type="info" class="save_btn" @click="saveHandle"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/;
export default {
  name: "editProfile",
  data() {
    return {
      userInfo: {
        name: "",
        idCardNo: "",
        gender: "",
        birthday: "",
        nation: "", //民族
        area: "",
        phone: "",
      },
      showBirthdayPicker: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2000, 0, 1)
    };
  },
  mounted(){
    this.getData()
  },
  methods: {
    getData() {
      this.$api.user.findUser().then((res) => {
        if (res.code == 0 && res.success) {
          this.userInfo = Object.assign({}, this.userInfo, res.data);
          this.currentDate = new Date(res.data.birthday);
        }
      });
    },
    toIdentify(){
      this.$router.push('/idcard')
    },
    back(){
        this.$router.go(-1);
    },
    //picker 选择框确定
    birthdayOnConfirm(date) {
      console.log(date);
      this.userInfo.birthday = this.formatime(date);
      this.showBirthdayPicker = false;
    },
    // 格式化时间
    formatime(dayCount) {
      const createtime = new Date(dayCount);
      const year = createtime.getFullYear();
      let month = createtime.getMonth() + 1;
      let day = createtime.getDate(); // 几号
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day + " 00:00:00";
    },
    genderValidator(val) {
      return !!this.userInfo.gender;
    },
    cancelHandle() {
      this.$router.go(-1)
    },
    //保存
    saveHandle() {
      this.$refs.validateForm
        .validate()
        .then(() => {
          // console.log(this.userInfo);
          this.$api.user.updateUser(this.userInfo).then((res) => {
            if (res.code == 0 && res.success) {
              this.$toast({
                message: "保存成功",
              });
              this.$router.go(-1)
            }
          });
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            message: error[0].message,
            className: "errorTY",
          });
        });
    },
  },
};
</script>


<style lang="stylus" scoped>
.editProfile {
  // height: 100vh;
  background: #f5f6fa;
  overflow: auto;

  .photo_box {
    position: relative;
    width: 200px;
    height: 280px;
    border-radius: 10px;
    overflow: hidden;
  }

  .my_photo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
    }

    .tips {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 200px;
      height: 56px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .re_uploadImg {
      width: 112px;
      height: 28px;
    }
  }

  .file_box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .file {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .space {
    height: 16px;
    width: 100%;
  }

  .handle_btn {
    width: 750px;
    height: 112px;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px #EAEAEA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    .cancel_btn {
      width: 332px;
      height: 88px;
      border-radius: 50px;
      border: 1px solid #1972FF;
      margin-right: 26px;
      color: #1972FF;
      font-size: 32px;
    }

    .save_btn {
      width: 332px;
      height: 88px;
      background: #1972FF;
      border-radius: 50px;
      font-size: 32px;
      color: #FFFFFF;
    }
  }
}
</style>
<style lang="stylus">
.editProfile {
  .van-uploader__wrapper {
    width: 100%;
    height: 100%;

    .van-uploader__upload {
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }

  .van-cell {
    min-height: 2.773rem;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    display: flex;
    align-items: center;
  }

  .van-cell--required::before {
    left: 0.8rem;
  }

  .van-cell.photo_wrap {
    align-items: flex-start;
    padding-top: 0.96rem;
    padding-bottom: 1.066rem;
  }

  .van-cell.block_field {
    display: block;
    padding-top: 0.8rem;
    padding-bottom: 0.9rem;

    .radio_group {
      margin-top: 0.9rem;
    }
  }
}

.van-toast.errorTY {
  background-color: #FF5758 !important;
}
</style>